module.exports = __webpack_public_path__ + "ace5e80780ff7a55e18dd17a166a415b.jpg";